import { AdvisorClientLatestOpportunityStatusData } from "@/models/AdvisorClientLatestOpportunityStatusData";
import { BaseParentDocumentService, ServiceNames } from "./BaseDocumentService";

export class OpportunityStatusService extends BaseParentDocumentService<
  AdvisorClientLatestOpportunityStatusData
> {
  serviceName = ServiceNames.OpportunityStatus;
}
